import { isNotEmpty } from "./validate";
export const getEntitiesFromArray = (array, options) => {
    const { key = "id", keyFormater } = options || {};
    const entitites = array.reduce((acc, entity) => {
        acc[keyFormater ? keyFormater(entity[key]) : entity[key]] = entity;
        return acc;
    }, {});
    return { entitites };
};
export const copyToClipboard = (text) => {
    const textField = document.createElement("textarea");
    textField.value = text?.toString() ?? "";
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    return () => {
        document.body.removeChild(textField);
    };
};
export const hexToRgba = (color, alpha = 1) => {
    const isHex = color.match(/^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/gm);
    const isRGB = color.match(/[Rr][Gg][Bb][(](((([\d]{1,3})[,]{0,1})[\s]*){3})[)]|[Rr][Gg][Bb][Aa][(](((([\d]{1,3}|[\d.]{1,3})[,]{0,1})[\s]*){4})[)]/gm);
    if (isHex) {
        const rgb = color
            .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)
            ?.substring(1)
            .match(/.{2}/g)
            ?.map((x) => parseInt(x, 16));
        if (!rgb || rgb.length < 3) {
            return color;
        }
        else {
            const [r, g, b] = rgb;
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }
    }
    else if (isRGB && alpha) {
        return color.replace(/[\d.]+\)$/g, `${alpha}`);
    }
    else {
        return color;
    }
};
export const rgbaToHex = (color) => {
    let a;
    const rgb = color.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
    const alpha = ((rgb && rgb[4]) || "").trim();
    let hex = rgb
        ? "#" +
            (rgb[1] | (1 << 8)).toString(16).slice(1) +
            (rgb[2] | (1 << 8)).toString(16).slice(1) +
            (rgb[3] | (1 << 8)).toString(16).slice(1)
        : color;
    if (alpha !== "") {
        a = alpha;
    }
    else {
        a = 0o1;
    }
    if (parseInt(a) !== 1) {
        a = ((a * 255) | (1 << 8)).toString(16).slice(1);
        hex = `${hex}${a}`;
    }
    return hex;
};
export const mergeRefs = (...refs) => {
    const filteredRefs = refs.filter(Boolean);
    if (!filteredRefs.length) {
        return null;
    }
    if (filteredRefs.length === 0) {
        return filteredRefs[0];
    }
    return (inst) => {
        for (const ref of filteredRefs) {
            if (typeof ref === "function") {
                ref(inst);
            }
            else if (ref) {
                ref.current = inst;
            }
        }
    };
};
export const getArrayMinMax = (arr) => {
    let len = arr.length;
    let min = Infinity;
    let max = -Infinity;
    while (len--) {
        min = arr[len] < min ? arr[len] : min;
        max = arr[len] > max ? arr[len] : max;
    }
    return { min, max };
};
export const getMatchingItems = (list, field, query) => list.filter((listItem) => !!listItem?.[field] && listItem?.[field]?.toLowerCase().indexOf(query.toLowerCase()) !== -1);
export const compareResultItemIds = ({ resultSetElementId, resultSetId }, payload, filter) => {
    if (filter) {
        return (resultSetId !== payload.resultSetId ||
            (resultSetId === payload.resultSetId && resultSetElementId !== payload.resultSetElementId));
    }
    else {
        return resultSetElementId === payload.resultSetElementId && resultSetId === payload.resultSetId;
    }
};
export const prepareItemsOnMove = (items, item, direction, toEnd) => {
    const elIndex = items.findIndex(({ id, position }) => id !== undefined ? id === item.id : position === item.position);
    if (toEnd) {
        if (direction === "before") {
            return items.reduce((acc, item, index) => {
                let preparedItem;
                if (index < elIndex) {
                    preparedItem =
                        item.id === undefined
                            ? { ...item, position: item.position + 1 }
                            : { id: item.id, position: item.position + 1 };
                }
                else if (index === elIndex) {
                    preparedItem = item.id === undefined ? { ...item, position: 1 } : { id: item.id, position: 1 };
                }
                else {
                    preparedItem = item.id === undefined ? item : { id: item.id, position: item.position };
                }
                return [...acc, preparedItem];
            }, []);
        }
        else {
            return items.reduce((acc, item, index) => {
                let preparedItem;
                if (index > elIndex) {
                    preparedItem =
                        item.id === undefined
                            ? { ...item, position: item.position - 1 }
                            : { id: item.id, position: item.position - 1 };
                }
                else if (index === elIndex) {
                    preparedItem =
                        item.id === undefined
                            ? { ...item, position: items.length }
                            : { id: item.id, position: items.length };
                }
                else {
                    preparedItem = item.id === undefined ? item : { id: item.id, position: item.position };
                }
                return [...acc, preparedItem];
            }, []);
        }
    }
    else {
        if (direction === "before") {
            return items.reduce((acc, item, index) => {
                let preparedItem;
                if (index === elIndex) {
                    preparedItem =
                        item.id === undefined
                            ? { ...item, position: item.position - 1 }
                            : { id: item.id, position: item.position - 1 };
                }
                else if (index === elIndex - 1) {
                    preparedItem =
                        item.id === undefined
                            ? { ...item, position: item.position + 1 }
                            : { id: item.id, position: item.position + 1 };
                }
                else {
                    preparedItem = item.id === undefined ? item : { id: item.id, position: item.position };
                }
                return [...acc, preparedItem];
            }, []);
        }
        else {
            return items.reduce((acc, item, index) => {
                let preparedItem;
                if (index === elIndex) {
                    preparedItem =
                        item.id === undefined
                            ? { ...item, position: item.position + 1 }
                            : { id: item.id, position: item.position + 1 };
                }
                else if (index === elIndex + 1) {
                    preparedItem =
                        item.id === undefined
                            ? { ...item, position: item.position - 1 }
                            : { id: item.id, position: item.position - 1 };
                }
                else {
                    preparedItem = item.id === undefined ? item : { id: item.id, position: item.position };
                }
                return [...acc, preparedItem];
            }, []);
        }
    }
};
export const getNextMaxId = (array = [], fieldName = "id") => {
    const currentMaxId = array.length === 0
        ? 0
        : Math.max(...array.map((item) => (isNotEmpty(item[fieldName]) ? item[fieldName] : 0)));
    return currentMaxId + 1;
};
export const getNewUniqueName = (base, existingNames) => {
    const baseOrder = 1;
    const baseName = `${base} ${baseOrder}`;
    const templatedNames = existingNames.filter((name) => {
        const nameChunks = name.split(" ");
        if (nameChunks[0].toLowerCase() === base.toLowerCase() &&
            !isNaN(Number(nameChunks[1])) &&
            nameChunks?.length === 2) {
            return true;
        }
        return false;
    });
    if (templatedNames?.length === 0)
        return baseName;
    for (let i = 0; i < templatedNames?.length + 1; ++i) {
        const proposedName = `${base} ${i + 1}`;
        if (!templatedNames?.includes(proposedName))
            return proposedName;
    }
    return baseName;
};
export const swapArrayItems = (arr, from, to) => {
    const newArr = [...arr];
    [newArr[from], newArr[to]] = [newArr[to], newArr[from]];
    return newArr;
};
export const formatPointCoord = (n) => (isNaN(n) ? 0 : n);
